export default {
  namespaced: true,
  state: {
    isLogin: false,
    activeName: '1067246875800000055',
    producList: [],
    routeParams: {},
    tradeResult: {}, // 申购交易结果页面
    currTradeResStepId: 1, // 申购步骤
    currRedeStepId:  1, // 赎回步骤
    fundDetailObj: {} ,// 基金详情
    // userInfo: {} ,// 当前登录用户信息
    redeObj: {}, // 当前基金赎回信息
    fundRedeObj: {}, // 赎回表单详情
    currTransStepId: 1, // 转换步骤
    transObj: {}, // 基金转换详情
    transFormObj: {}, // 转换基金表单详情
    createAcconStep:  1, // 开户步骤
    createAccoInfo: {}, // 开户信息
    openAccoProtocolList: [], // 开户时的协议信息
    modifyFixStepId: 1, // 修改定投步骤
    fixModifyRowObj: {}, // 修改当前定投基金详情
    fixFormObj: {}, // 当前定投基金表单详情
    fixResultObj: {}, // 修改定投结果
    // warningAContent: '',
    newFixStepId: 1, // 创建定投步骤
    fixNewFormObj: {}, // 创建定投基金表单详情
    newFixResultObj: {}, // 创建定投结果
    newFixFund: '', // 选择创建定投基金
    currNewFixStepId: 1, // 当前基金定投步骤
    currFixFundObj: {}, // 当前基金定投
    currFixResultObj: {}, // 当前基金定投结果
    superXjbCurrStepId:1, // 超宝立即充值步骤
    superXjbDetailObj:{}, // 超宝立即充值交易详情
    superXjbTradeResult:{}, // 当前超宝立即买入结果
    superXjbFixStepId:1, // 超宝定期充值步骤
    superXjbFixDetailObj:{}, // 超宝定期充值交易详情
    superXjbRedeemStepId:1, // 超宝取现步骤
    superXjbRedeemDetailObj:{}, // 超宝取现交易详情
  },
  mutations: {
    setIsLogin(state, params) {
      state.isLogin = params
    },
    // setSdxWarningA (state, params) {
    //   state.warningAContent = params
    // },
    handleActiveName(state, params) {
      state.activeName = params
    },
    setProductList(state, params) {
      state.producList = params
    },
    setRouteParams(state, params) {
      state.routeParams = params
    },
    setTradeResult(state, params) {
      state.tradeResult = params
    },
    setSuperXjbTradeResult(state, params) {
      state.superXjbTradeResult = params
    },
    setCurrTradeStep(state, params) {
      state.currTradeResStepId = params
    },
    setSuperXjbStep(state, params) {
      state.superXjbCurrStepId = params
    },
    setSuperXjbFixStep(state, params) {
      state.superXjbFixStepId = params
    },
    setSuperXjbRedeemStep(state, params) {
      state.superXjbRedeemStepId = params
    },
    setFundDetailObj(state, params) {
      state.fundDetailObj = params
    },
    setSuperXjbDetailObj(state, params){
      state.superXjbDetailObj = params
    },
    setSuperXjbFixDetailObj(state, params){
      state.superXjbFixDetailObj = params
    },
    setSuperXjbRedeemDetailObj(state, params){
      state.superXjbRedeemDetailObj = params
    },
    setRedeObj(state, params) {
      state.redeObj = params
    },
    setCurrRedeStep(state, params) {
      state.currRedeStepId = params
    },
    setFundRedeObj(state, params) {
      state.fundRedeObj = params
    },
    setCurrTransStep(state, params) {
      state.currTransStepId = params
    },
    setModifyFixStep(state, params) {
      state.modifyFixStepId = params
    },
    setNewFixStep(state, params) {
      state.newFixStepId = params
    },
    setTransObj(state, params) {
      state.transObj = params
    },
    setTransFormObj(state, params) {
      state.transFormObj = params
    },
    setfixRowObj(state, params) {
      state.fixModifyRowObj = params
    },
    setFixFormObj(state, params) {
      state.fixFormObj = params
    },
    setFixResultObj(state, params) {
      state.fixResultObj = params
    },
    setFixNewFormObj(state, params) {
      state.fixNewFormObj = params
    },
    setNewFixResultObj(state, params) {
      state.newFixResultObj = params
    },
    setNewFixFund(state, params) {
      state.newFixFund = params
    },
    clearTradeList(state, params) {
      state.currTradeResStepId = 1
      state.fundDetailObj = {}
      state.tradeResult = {}
    },
    clearSuperXjbTradeList(state) {
      state.superXjbCurrStepId = 1
      state.superXjbDetailObj = {}
      state.superXjbTradeResult = {}
    },
    clearSuperXjbFixTradeList(state) {
      state.superXjbFixStepId = 1
      state.superXjbFixDetailObj = {}
    },
    clearSuperXjbRedeemTradeList(state) {
      state.superXjbRedeemStepId = 1
      state.superXjbRedeemDetailObj = {}
    },
    clearRedeList(state, params) {
      state.currRedeStepId = 1
      state.redeObj = {}
      state.fundRedeObj = {} 
    },
    clearTransList(state, params) {
      state.currTransStepId = 1
      state.transObj = {}
      state.transFormObj = {}
    },
    clearFixedList(state, params) {
      state.modifyFixStepId = 1
      state.fixModifyRowObj = {}
      state.fixFormObj = {}
      state.fixResultObj = {}
    },
    clearNewFixedList(state, params) {
      state.newFixStepId = 1
      state.fixNewFormObj = {}
      state.newFixResultObj = {}
      state.newFixFund = ''
    },
    clearCurrFixedList(state, params) {
      state.currNewFixStepId = 1
      state.currFixFundObj = {}
      state.currFixResultObj = {}

    },
    clearMainLogoutInfo(state) {
      state.activeName = ''
      state.routeParams = {}
      state.producList = []
      state.isLogin = false;
    },
    // setUserInfo(state, params) {
    //   state.userInfo = params
    // },
    setCreateAcconStep(state, params) {
      state.createAcconStep = params
    },
    setCreateAccoInfo(state, params) {
      // 直接赋值可能破坏响应式
      state.createAccoInfo = Object.assign({}, params)
    },
    setCurrFixFundObj(state, params) {
      state.currFixFundObj = params
    },
    setCurrNewFixStep(state, params) {
      state.currNewFixStepId = params
    },
    setCurrFixResultObj(state, params) {
      state.currFixResultObj = params
    },
    setOpenAccoProtocolList(state, params) {
      state.openAccoProtocolList = params
    },
  },
  actions: {
    // getSdxWarningA ({commit}, params) {
    //   commit('setSdxWarningA', params)
    // },
    getIsLogin ({commit}, params) {
      commit('setIsLogin', params)
    },
    getFundProList ({commit}, params) {
      commit('setProductList', params)
    },
    getRouteParams ({commit}, params) {
      commit('setRouteParams', params)
    },
    getTradeResult({commit}, params) {
      commit('setTradeResult', params)
    },
    getSuperXjbTradeResult({commit}, params) {
      commit('setSuperXjbTradeResult', params)
    },
    getCurrTradeStep({commit}, params) {
      commit('setCurrTradeStep', params)
    },
    getSuperXjbCurrStep({commit}, params) {
      commit('setSuperXjbStep', params)
    },
    getSuperXjbFixStep({commit}, params) {
      commit('setSuperXjbFixStep', params)
    },
    getSuperXjbRedeemStep({commit}, params) {
      commit('setSuperXjbRedeemStep', params)
    },
    getModifyFixStep({commit}, params) {
      commit('setModifyFixStep', params)
    },
    getNewFixStep({commit}, params) {
      commit('setNewFixStep', params)
    },
    getFundDetailObj({commit}, params) {
      commit('setFundDetailObj', params)
    },
    getSuperXjbDetailObj({commit}, params) {
      commit('setSuperXjbDetailObj', params)
    },
    getSuperXjbFixDetailObj({commit}, params) {
      commit('setSuperXjbFixDetailObj', params)
    },
    getSuperXjbRedeemDetailObj({commit}, params) {
      commit('setSuperXjbRedeemDetailObj', params)
    },
    getRedeObj({commit}, params) {
      commit('setRedeObj', params)
    },
    getFundRedeObj({commit}, params) {
      commit('setFundRedeObj', params)
    },
    getCurrRedeStep({commit}, params) {
      commit('setCurrRedeStep', params)
    },
    getCurrTransStep({commit}, params) {
      commit('setCurrTransStep', params)
    },
    getTransObj({commit}, params) {
      commit('setTransObj', params)
    },
    getTransFormObj({commit}, params) {
      commit('setTransFormObj', params)
    },
    getFixRowObj({commit}, params) {
      commit('setfixRowObj', params)
    },
    getFixFormObj({commit}, param) {
      commit('setFixFormObj', param)
    },
    getFixNewFormObj({commit}, param) {
      commit('setFixNewFormObj', param)
    },
    getFixResultObj({commit}, param) {
      commit('setFixResultObj', param)
    },
    getNewFixResultObj({commit}, param) {
      commit('setNewFixResultObj', param)
    },
    getNewFixFund({commit}, param) {
      commit('setNewFixFund', param)
    },
    // getUserInfo({commit}, params) {
    //   commit('setUserInfo', params)
    // },
    getCreateAcconStep({commit}, params) {
      commit('setCreateAcconStep', params)
    },
    getCreateAccoInfo({commit}, params) {
      commit('setCreateAccoInfo', params)
    },
    getCurrFixFundObj({commit}, params) {
      commit('setCurrFixFundObj', params)
    },
    getCurrNewFixStep({commit}, params) {
      commit('setCurrNewFixStep', params)
    },
    getCurrFixResultObj({commit}, param) {
      commit('setCurrFixResultObj', param)
    },
    getOpenAccoProtocolList({commit}, params) {
      commit('setOpenAccoProtocolList', params)
    },
  }
}
